import React from "react";

export default function ArchiveCompanyModal({
  show,
  onClose,
  onConfirm,
  company,
  isLoading,
}) {
  if (!show || !company) return null;

  const isArchived = company.archive;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-700">
            {isArchived ? "Restore Company" : "Archive Company"}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <i className="fa fa-times"></i>
          </button>
        </div>
        <div className="mb-6">
          <p className="text-base text-gray-700">
            {isArchived
              ? `Are you sure you want to restore "${company.name}"? This will make it active again.`
              : `Are you sure you want to archive "${company.name}"? This will archive all associated staff, locations, schedules, and timesheets for this company. This action can be undone later.`}
          </p>
        </div>
        <div className="flex gap-3 justify-end">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className={`px-4 py-2 text-white rounded-md transition disabled:opacity-50 ${
              isArchived
                ? "bg-green-500 hover:bg-green-600"
                : "bg-red-500 hover:bg-red-600"
            }`}
          >
            {isArchived ? "Restore" : "Archive"}
          </button>
        </div>
      </div>
    </div>
  );
}

